// HomeImageText.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import s from './HomeImageText.module.scss';
import Image from '../Image';

const textVariants = {
    hidden: { opacity: 0, y: 150 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 100,
            damping: 16,
            delay: 0.2,
        },
    },
};

const backgroundVariants = {
    hidden: { y: 50, x: 20 },
    visible: {
        y: 0,
        x: 0,
        transition: {
            type: 'tween',
            duration: 0.4,
            ease: 'easeOut',
            delay: 0.2,
        },
    },
};

const renderTextWithHighlights = (input) =>
    input.split(/(\s+)/).map((chunk, i) =>
        chunk.startsWith('#') ? (
            <span key={i} className={s.Highlight}>
                {chunk.slice(1)}
            </span>
        ) : (
            <span key={i}>{chunk}</span>
        )
    );

const HomeImageText = ({ image, text = '' }) => (
    <div className={s.Root}>
        <div className={s.Container}>
            <div className={s.ImageContainer}>
                {image && (
                    <>
                        <motion.div
                            className={s.Background}
                            variants={backgroundVariants}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }}
                        />
                        <div className={s.ClipContainer}>
                            <div className={s.Image}>
                                <Image {...image} />
                            </div>
                        </div>
                    </>
                )}
            </div>

            <motion.div
                className={s.TextContainer}
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}>
                <p className={s.Text}>{renderTextWithHighlights(text)}</p>
            </motion.div>
        </div>
    </div>
);

HomeImageText.propTypes = {};

export default HomeImageText;
